import { render, staticRenderFns } from "./SpiderChart1.vue?vue&type=template&id=448153aa&"
import script from "./SpiderChart1.vue?vue&type=script&lang=js&"
export * from "./SpiderChart1.vue?vue&type=script&lang=js&"
import style0 from "./SpiderChart1.vue?vue&type=style&index=0&id=448153aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports